(ns motorsaif.version
  (:require
   [motorsaif.macros :as macros]))

(def version "0.105")
(def dt #(macros/dt))
(def git-hash #(macros/git-hash))
